import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Switch to new design to use the Creator Account Setup", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewCreatorAccountSetup = _resolveComponent("NewCreatorAccountSetup")!

  return (_ctx.isInfluencerProfileEnabled)
    ? (_openBlock(), _createBlock(_component_NewCreatorAccountSetup, {
        key: 0,
        router: _ctx.router
      }, null, 8, ["router"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}